<template>
  <div :class="`${isNotTopList || isMobile ? '' : 'form-list'}`">

    <template v-if="!isHideFilter">
      <div class="filter-container">
        <slot name="header-item-first"/>
        <template v-if="isShowStoreSelect">
          <v-select-store
            v-if="isMultipleStore"
            :class="`${storeSelectLabel ? '' : 'table-filter-select'}`"
            v-model="store_ids"
            :clearable="isStoreSelectClearable"
            :has-private="hasPrivateStore"
            :multiple="true"
            :collapse="true"
            @input="handleStoreChange"
            size="small"
            placeholder="门店"
            :label="storeSelectLabel"
          />
          <v-select-store
            v-else
            v-model="query.store_id"
            :clearable="isStoreSelectClearable"
            :has-private="hasPrivateStore"
            @input="handleChange"
            :class="`${storeSelectLabel ? '' : 'table-filter-select'}`"
            size="small"
            :label="storeSelectLabel"
            placeholder="门店"
          />
        </template>

        <v-select-store
          v-if="isShowLimitStoreSelect"
          :class="`${limitStoreSelectLabel ? '' : 'table-filter-select'}`"
          v-model="limit_store_ids"
          :clearable="true"
          :has-private="hasPrivateLimitStore"
          :multiple="isMultipleLimitStore"
          :collapse="true"
          @input="handleLimitStoreChange"
          size="small"
          placeholder="限制门店"
          :label="limitStoreSelectLabel"
        />

        <v-select-administrator
          v-if="isShowAdministratorSelect"
          v-model="administrator_ids"
          :class="`${administratorSelectLabel ? '' : 'table-filter-select'}`"
          size="small"
          :label="administratorSelectLabel"
          :clearable="true"
          :multiple="true"
          :remote="true"
          :collapse="true"
          placeholder="请输入信息搜索选择管理员"
          @input="handleAdministratorChange"
        />

        <v-select-apply-state
          v-if="isShowApplyStateSelect"
          v-model="apply_states"
          :class="`${applyStateSelectLabel ? '' : 'table-filter-select'}`"
          size="small"
          :label="applyStateSelectLabel"
          :clearable="true"
          :multiple="true"
          placeholder="请选择审核状态"
          @input="handleApplyStateChange"
        />

        <v-select-administrator
          v-if="isShowAddAdministratorSelect"
          v-model="add_administrator_ids"
          :class="`${addAdministratorSelectLabel ? '' : 'table-filter-select'}`"
          size="small"
          :label="addAdministratorSelectLabel"
          :clearable="true"
          :multiple="true"
          :remote="true"
          :collapse="true"
          placeholder="请输入信息搜索选择管理员"
          @input="handleChange({ idsKey: 'add_administrator_ids' })"
        />
        <v-select-administrator
          v-if="isShowUpdateAdministratorSelect"
          v-model="update_administrator_ids"
          :class="`${updateAdministratorSelectLabel ? '' : 'table-filter-select'}`"
          size="small"
          :label="updateAdministratorSelectLabel"
          :clearable="true"
          :multiple="true"
          :remote="true"
          :collapse="true"
          placeholder="请输入信息搜索选择管理员"
          @input="handleChange({ idsKey: 'update_administrator_ids' })"
        />

        <v-select-student
          v-if="isShowStudentSelect"
          v-model="student_ids"
          :class="`${studentSelectLabel ? '' : 'table-filter-select'}`"
          size="small"
          :label="studentSelectLabel"
          :clearable="true"
          :multiple="true"
          :remote="true"
          :collapse="true"
          placeholder="请输入信息搜索选择学员"
          @input="handleStudentChange"
        />

        <v-select-reserve-state
          v-if="isShowReserveStateSelect"
          v-model="reserve_states"
          :class="`${reserveStateSelectLabel ? '' : 'table-filter-select'}`"
          size="small"
          :label="reserveStateSelectLabel"
          :clearable="true"
          :multiple="true"
          :remote="true"
          :collapse="true"
          placeholder="请选择预约状态"
          @input="handleReserveStateChange"
        />

        <v-select-student-update-type
          v-if="isShowStudentUpdateTypeSelect"
          v-model="student_update_types"
          :class="`${studentUpdateTypeSelectLabel ? '' : 'table-filter-select'}`"
          size="small"
          :label="studentUpdateTypeSelectLabel"
          :is-filter-update-all="true"
          :clearable="true"
          :multiple="true"
          :collapse="true"
          placeholder="请选择资料修改类型"
          @input="handleStudentUpdateTypeChange"
        />

        <v-select-teacher
          class="table-filter-select table-filter-select-teacher"
          v-if="isShowTeacherSelect"
          v-model="teacher_ids"
          :store-id="query.store_id"
          :clearable="true"
          :multiple="true"
          :remote="true"
          :collapse="true"
          @input="handleTeacherChange"
          size="small"
        />

        <el-select
          class="table-filter-select"
          v-if="isShowTagName"
          v-model="query.tag_name"
          filterable
          clearable
          allow-create
          placeholder="输入课程标签"
          @change="handleChange"
          size="small"
        />

        <v-select-card-state
          v-if="isShowSelectCardState"
          v-model="query.card_state"
          :class="`${cardStateSelectLabel ? '' : 'table-filter-select'}`"
          :label="cardStateSelectLabel"
          size="small"
          placeholder="课卡状态"
          @input="handleChange"
        />

        <v-select-card-update-state
          class="table-filter-select"
          v-if="isShowSelectCardUpdateState"
          v-model="query.card_update_state"
          @input="handleChange"
          size="small"
          placeholder="审核状态"
        />

        <v-select-card-update-state
          class="table-filter-select"
          v-if="isShowState"
          v-model="query.state"
          @input="handleChange"
          size="small"
          placeholder="审核状态"
        />

        <v-select-card-type-id
          v-if="isShowSelectCardTypeId"
          v-model="query.card_type_id"
          :class="`${cardTypeSelectLabel ? '' : 'table-filter-select'}`"
          :label="cardTypeSelectLabel"
          :clearable="true"
          size="small"
          placeholder="课卡类型"
          @input="handleChange"
        />

        <div v-if="isShowSelectCardIsNew" class="flex-wrap table-filter-item">
          <div class="flex-align-center table-filter-label">新老生：</div>
          <!-- 有 label 时不能再加 table-filter-select：该 class 带 16px 下边距，会把下拉框顶出同一水平线 -->
          <el-select
            v-model="query.is_new"
            style="width: 140px"
            clearable
            placeholder="新老生"
            size="small"
            @change="handleChange"
          >
            <el-option
              v-for="item in cardIsNewTypes"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </div>

        <v-select-card-update-type
          v-if="isShowSelectCardUpdateType"
          v-model="update_types"
          :class="`${cardUpdateTypeSelectLabel ? '' : 'table-filter-select'}`"
          :label="cardUpdateTypeSelectLabel"
          :clearable="true"
          :multiple="true"
          size="small"
          placeholder="请选择操作分类"
          @input="handleCardUpdateTypeChange"
        />

        <v-select-card-charge-type
          v-if="isShowSelectCardChargeType"
          v-model="card_charge_type_ids"
          :cardTypeId="query.card_type_id"
          :class="`${cardChargeTypeSelectLabel ? '' : 'table-filter-select'}`"
          size="small"
          :label="cardChargeTypeSelectLabel"
          :clearable="true"
          :multiple="true"
          :collapse="true"
          placeholder="请输入信息搜索课卡套餐"
          @input="handleCardChargeTypeChange"
          :ids="card_charge_type_ids"
        />

        <v-select-course-column
          class="table-filter-select"
          v-if="isShowSelectCourseColumnId"
          v-model="query.course_column_id"
          @input="handleChange"
          :clearable="true"
          size="small"
          placeholder="输入专栏名称"
        />

        <template v-if="isShowSelectCardPaymentModeId">
          <v-select-card-payment-mode
            v-if="isCardPaymentModeMultiple"
            :class="`${cardPaymentModeLabel ? '' : 'table-filter-select'}`"
            v-model="card_payment_mode_ids"
            :label="cardPaymentModeLabel"
            :clearable="true"
            :multiple="isCardPaymentModeMultiple"
            size="small"
            placeholder="收款方式"
            @input="handleChange({ idsKey: 'card_payment_mode_ids' })"
          />
          <v-select-card-payment-mode
            v-else
            :class="`${cardPaymentModeLabel ? '' : 'table-filter-select'}`"
            v-model="query.card_payment_mode_id"
            :label="cardPaymentModeLabel"
            :clearable="true"
            size="small"
            placeholder="收款方式"
            @input="handleChange"
          />
        </template>


        <v-tab-quick-time
          v-if="isShowQuickTimeTab"
          v-model="timeLimit"
          :picker-options="pickerOptions"
          :is-show-week="isShowQuickTimeTabWeek"
          :is-show-next-week="isShowQuickTimeTabNextWeek"
          :is-show-last-thirty-day="isShowQuickTimeTabLastThirtyDay"
          :is-show-month="isShowQuickTimeTabMonth"
          :is-show-last-month="isShowQuickTimeTabLastMonth"
          :label="quickTimeTabLabel"
          size="small"
          @input="handleTimeLimitChange"
        />

        <el-date-picker
          class="table-filter-item"
          type="month"
          value-format="yyyy-MM"
          v-if="isShowDatePicker"
          v-model="query.date"
          :picker-options="pickerOptions"
          @change="handleDateChange"
          size="small"
          placeholder="月份"
        />

        <v-month-range-picker
          class="table-filter-item"
          v-if="isShowMonthRangePicker"
          v-model="timeLimit"
          :picker-options="pickerOptions"
          @input="handleTimeLimitChange"
          size="small"
        />

        <div v-if="isShowDistinctSwitch" class="flex-wrap table-filter-item">
          <div class="flex-align-center table-filter-label">仅显示每位学员的最新修改记录：</div>
          <el-switch
            v-model="query.is_distinct"
            :active-value="1"
            :inactive-value="0"
            @change="handleDistinctChange"
          />
        </div>

        <el-switch
          v-if="isShowMajorSwitch"
          v-model="query.is_major"
          :active-value="1"
          :inactive-value="0"
          active-text="专业班"
          inactive-text="少儿班及成人班"
          class="table-filter-item"
          @change="handleMajorFilterChange"
        />

        <div v-if="isShowExpireNumbers" class="flex-wrap flex-align-center table-filter-item">
          <div class="table-filter-label">剩余次数：</div>
          <div class="flex-center">
            <v-input-money
              class="table-filter-expire-number"
              v-model="query.expire_number_min"
              size="small"
              :is-show-suffix="true"
              suffix-name="次"
              @blur="handleExpireNumbersChange"
            />
            <div class="table-filter-label-divider">至</div>
            <v-input-money
              class="table-filter-expire-number"
              v-model="query.expire_number_max"
              size="small"
              :is-show-suffix="true"
              suffix-name="次"
              @blur="handleExpireNumbersChange"
            />
          </div>
        </div>

        <div v-if="isShowGroupCount" class="flex-align-center table-filter-item">
          <div class="table-filter-label">{{ groupCountLabel }}：</div>
          <v-input-number
            class="table-filter-expire-number"
            v-model="query.group_count"
            size="small"
            :is-show-suffix="true"
            :min="0"
            :max="9999"
            suffix-name="次"
            @blur="handleExpireNumbersChange"
          />
        </div>

        <slot name="header-item"/>

        <v-search-input
          class="flex-align-center"
          v-if="isShowSearchInput"
          v-model="query.keyword"
          @search="handleSearch"
          size="small"
          :placeholder="searchPlaceholder"
        />

        <el-button
          class="table-filter-item table-filter-button"
          v-if="isShowXlsExportButton"
          size="small"
          plain
          @click="exportExcel(excelData, excelName)"
        >
          导出 Excel
        </el-button>

        <div
          v-if="isShowExportALl"
          class="table-filter-item"
          @click="() => $emit('exportAllExcel')"
        >
          <el-button
            size="small"
            plain
            :loading="isExportingAll"
          >
            {{ exportAllText }}
          </el-button>
        </div>
      </div>

      <div v-if="!isMobile" class="divider-box"></div>
    </template>

    <slot name="summary"/>

    <slot v-if="isMobile" name="mobile-list"/>
    <template v-else>
      <el-table
        v-loading="isLoading"
        :data="list"
        highlight-current-row
        @sort-change="handleDirectionChange"
        :show-summary="showSummary"
        :summary-method="getTableSummaries"
        :row-class-name="rowClassName"
        :row-key="rowKey || undefined"
        :expand-row-keys="resolvedExpandRowKeys"
        ref="vtable"
      >
        <slot/>
        <!-- 列表列全部定宽时，Element 会把表格宽度收缩为列宽之和，右侧留下一段没有行线的空白；
             这里在末尾补一个不可见弹性列吸收剩余宽度。页面本身已有弹性列时表格已铺满，不再补列，
             避免多列分摊剩余宽度、以及列宽恰好等于容器时多出 1px 横向滚动条。 -->
        <el-table-column
          v-if="showFillerColumn"
          :class-name="fillerColumnClass"
          min-width="1"
        />
        <div slot="append">
          <slot name="append"/>
        </div>
      </el-table>

      <div class="divider-box"></div>
    </template>

    <v-pagination
      :count="count"
      :page="query.page"
      :size="query.size"
      :auto-scroll="autoScroll"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import { pickerOptionsBetweenSystemStartAndToday } from "@/utils/formats";
import { getTableSummaries } from '@/utils/number';
import exportExcel from '@/utils/excel-export';
import cardIsNewTypes from '@/enums/cardIsNewTypes';

export default {
  props: {
    isShowStoreSelect: Boolean,
    isMultipleStore: Boolean,
    isStoreSelectClearable: Boolean,
    isShowSearchInput: Boolean,
    isShowQuickTimeTab: Boolean,
    isShowQuickTimeTabWeek: {
      type: Boolean,
      default: true,
    },
    isShowQuickTimeTabNextWeek: Boolean,
    isShowQuickTimeTabLastThirtyDay: Boolean,
    isShowQuickTimeTabMonth: Boolean,
    isShowQuickTimeTabLastMonth: Boolean,
    isShowMonthRangePicker: Boolean,
    isShowDatePicker: Boolean,
    isShowMajorSwitch: Boolean,
    isShowDistinctSwitch: Boolean,
    isShowSelectCardState: Boolean,
    isShowSelectCardIsNew: Boolean,
    isShowSelectCardUpdateState: Boolean,
    isShowState: Boolean,
    isShowSelectCardChargeType: Boolean,
    isShowSelectCardTypeId: Boolean,
    isShowSelectCardUpdateType: Boolean,
    isShowSelectCourseColumnId: Boolean,
    isShowSelectCardPaymentModeId: Boolean,
    isCardPaymentModeMultiple: Boolean,
    isShowXlsExportButton: Boolean,
    isHideFilter: Boolean,
    hasPrivateStore: Boolean,
    isShowLimitStoreSelect: Boolean,
    isMultipleLimitStore: {
      type: Boolean,
      default: true,
    },
    hasPrivateLimitStore: Boolean,
    isLoading: Boolean,
    isNotTopList: Boolean,
    count: Number,
    list: Array,
    excelData: Array,
    defaultOrderBy: {
      type: String,
      default: 'add_time',
    },
    defaultIsAsc: Boolean,
    queryList: Object,
    pushList: Function,
    rowClassName: Function,
    rowKey: {
      type: String,
      default: '',
    },
    expandRowKeys: {
      type: Array,
      default: () => [],
    },
    pickerOptions: {
      type: Object,
      default: () => pickerOptionsBetweenSystemStartAndToday,
    },
    showSummary: Boolean,
    isShowAdministratorSelect: Boolean,
    isShowAddAdministratorSelect: Boolean,
    isShowUpdateAdministratorSelect: Boolean,
    isShowStudentSelect: Boolean,
    isShowApplyStateSelect: Boolean,
    isShowReserveStateSelect: Boolean,
    isShowStudentUpdateTypeSelect: Boolean,
    isShowTeacherSelect: Boolean,
    isShowTagName: Boolean,
    isShowExpireNumbers: Boolean,
    isShowGroupCount: Boolean,
    administratorSelectLabel: {
      type: String,
      default: '',
    },
    addAdministratorSelectLabel: {
      type: String,
      default: '',
    },
    cardStateSelectLabel: {
      type: String,
      default: '',
    },
    cardTypeSelectLabel: {
      type: String,
      default: '',
    },
    cardUpdateTypeSelectLabel: {
      type: String,
      default: '',
    },
    cardChargeTypeSelectLabel: {
      type: String,
      default: '',
    },
    updateAdministratorSelectLabel: {
      type: String,
      default: '',
    },
    storeSelectLabel: {
      type: String,
      default: '',
    },
    limitStoreSelectLabel: {
      type: String,
      default: '',
    },
    studentSelectLabel: {
      type: String,
      default: '',
    },
    applyStateSelectLabel: {
      type: String,
      default: '',
    },
    reserveStateSelectLabel: {
      type: String,
      default: '',
    },
    studentUpdateTypeSelectLabel: {
      type: String,
      default: '',
    },
    quickTimeTabLabel: {
      type: String,
      default: '',
    },
    cardPaymentModeLabel: {
      type: String,
      default: '',
    },
    searchPlaceholder: {
      type: String,
      default: '输入姓名、手机号或卡号',
    },
    summaryTitle: {
      type: String,
      default: '合计',
    },
    excelName: {
      type: String,
      default: '数据列表',
    },
    isShowExportALl: Boolean,
    isExportingAll: Boolean,
    // 翻页/切换每页条数后是否自动滚回页面顶部（部分页面表格上方有大量统计图表，滚动反而看不到列表，可关闭）
    autoScroll: {
      type: Boolean,
      default: true,
    },
    exportAllText: {
      type: String,
      default: '导出全部至 Excel',
    },
    groupCountLabel: {
      type: String,
      default: '分组最小记录数',
    },
  },
  data: () => ({
    query: {},
    cardIsNewTypes,
    // 表格是否已补“填满容器”的弹性列；只在全部列定宽且仍有剩余宽度时开启
    showFillerColumn: false,
    fillerColumnClass: 'v-table-filler-column',
    lastKeyword: '',
    timeLimit: ['', ''],
    administrator_ids: [],
    add_administrator_ids: [],
    update_administrator_ids: [],
    student_ids: [],
    card_charge_type_ids: [],
    apply_states: [],
    reserve_states: [],
    student_update_types: [],
    teacher_ids: [],
    store_ids: [],
    limit_store_ids: [],
    card_payment_mode_ids: [],
    update_types: [],
  }),
  watch: {
    queryList : {
      handler(queryList) {
        this.setQueryParams(queryList);
      },
      immediate: true, // 立即执行一次
      deep: true,
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    // Element 只要收到 expand-row-keys（空数组也算）就会校验 row-key，
    // 未声明 row-key 的普通列表不能传该属性，否则每个列表页都会抛错
    resolvedExpandRowKeys() {
      return this.rowKey ? this.expandRowKeys : null;
    },
  },
  methods: {
    exportExcel,
    getTableSummaries,
    setQueryParams(queryList) {
      const query = { ...queryList };
      const fieldsToProcess = [
        'administrator_ids',
        'add_administrator_ids',
        'update_administrator_ids',
        'student_ids',
        'card_charge_type_ids',
        'apply_states',
        'reserve_states',
        'student_update_types',
        'teacher_ids',
        'store_ids',
        'card_payment_mode_ids',
        'update_types',
      ];
      this.isShowLimitStoreSelect && fieldsToProcess.push('limit_store_ids');

      const arrayProperties = {};
      fieldsToProcess.forEach(key => {
        query[key] = Array.isArray(queryList[key]) ? queryList[key].join(',') : '';
        arrayProperties[key] = queryList[key] || [];
      });
      if (!this.isShowLimitStoreSelect) delete query.limit_store_ids;

      query.page = parseInt(queryList.page) || 1;
      query.size = parseInt(queryList.size) || 10;
      Object.assign(this.query, query);
      Object.assign(this, arrayProperties);
      query.size = parseInt(queryList.size) || 10;

      this.setTimeLimit(queryList);
    },
    setTimeLimit(queryList) {
      this.timeLimit = this.isValidDate(queryList.start_date) && this.isValidDate(queryList.end_date)
          ? [queryList.start_date, queryList.end_date]
          : [];
    },
    isValidDate(dateString) {
      if (!dateString) return false;

      const dateFormat = /^\d{4}-\d{2}(-\d{2})?$/;
      return dateFormat.test(dateString);
    },
    // 全部列定宽时补一个不可见弹性列，让表头线、行线、合计线都通到容器右边缘。
    // 已有弹性列（未写 width / 只写 min-width）时表格本来就会铺满，不能再补，
    // 否则剩余宽度会在两个弹性列之间分摊；列宽总和恰好等于容器时补列还会多出 1px 滚动条。
    syncFillerColumn() {
      const table = this.$refs.vtable;
      if (!table || !table.layout || !table.$el) return;

      const columns = (table.store.states.columns || []).filter(
        (column) => column.className !== this.fillerColumnClass,
      );
      if (!columns.length) return;

      const hasFlexibleColumn = columns.some((column) => typeof column.width !== 'number');
      const fixedWidth = columns.reduce(
        (total, column) => total + (typeof column.width === 'number' ? column.width : (column.minWidth || 80)),
        0,
      );
      const scrollBarWidth = table.layout.scrollY ? table.layout.gutterWidth : 0;
      const availableWidth = table.$el.clientWidth - scrollBarWidth;
      const showFillerColumn = !hasFlexibleColumn && availableWidth - fixedWidth >= 1;

      if (showFillerColumn !== this.showFillerColumn) this.showFillerColumn = showFillerColumn;
    },
    refresh() {
      this.pushList(this.query);
    },
    handleChange({ idsKey = '' }) {
      if (idsKey) this.query[idsKey] = this[idsKey].join(',');
      this.query.page = 1;
      this.refresh();
    },
    handleDirectionChange(direction) {
      // 排序只有两个方向：默认倒序，点击则取反（转正序）
      const isAsc = !+this.query.is_asc;
      Object.assign(this.query, {
        order_by: direction.prop,
        is_asc: isAsc ? 1 : 0,
        page: 1,
      })
      // Element 自身的 column.order 会因跨列点击而与项目方向失配，
      // 导致表头两个箭头同时高亮；让它跟随 is_asc，箭头才与数据一致。
      // 顺带避免第三次点击时 Element 把排序清空，保持两个方向。
      if (direction.column) {
        direction.column.order = isAsc ? 'ascending' : 'descending';
      }
      this.refresh();
    },
    handleAdministratorChange(administrator_ids) {
      this.query.administrator_ids = administrator_ids.join(',');
      this.query.page = 1;
      this.refresh();
    },
    handleStudentChange(student_ids) {
      this.query.student_ids = student_ids.join(',');
      this.query.page = 1;
      this.refresh();
    },
    handleCardChargeTypeChange(card_charge_type_ids) {
      this.query.card_charge_type_ids = card_charge_type_ids.join(',');
      this.query.page = 1;
      this.refresh();
    },
    handleApplyStateChange(apply_states) {
      this.query.apply_states = apply_states.join(',');
      this.query.page = 1;
      this.refresh();
    },
    handleReserveStateChange(reserve_states) {
      this.query.reserve_states = reserve_states.join(',');
      this.query.page = 1;
      this.refresh();
    },
    handleStudentUpdateTypeChange(student_update_types) {
      this.query.student_update_types = student_update_types.join(',');
      this.query.page = 1;
      this.refresh();
    },
    handleCardUpdateTypeChange(update_types) {
      this.query.update_types = update_types.join(',');
      this.query.page = 1;
      this.refresh();
    },
    handleTeacherChange(teacher_ids) {
      this.query.teacher_ids = teacher_ids.join(',');
      this.query.page = 1;
      this.refresh();
    },
    handleStoreChange(store_ids) {
      this.query.store_ids = store_ids.join(',');
      this.query.page = 1;
      this.refresh();
    },
    handleLimitStoreChange(limit_store_ids) {
      this.query.limit_store_ids = limit_store_ids.join(',');
      this.query.page = 1;
      this.refresh();
    },
    handlePageChange({ page, size }) {
      const currentPage = parseInt(this.$route.query.page || 0) || 1;
      const currentSize = parseInt(this.$route.query.size || 0) || 10;
      if (page === currentPage && size === currentSize) return;

      this.query.page = page;
      this.query.size = size;
      this.refresh();
    },
    handleTimeLimitChange(times) {
      if (!times || !times.length) times = [];

      this.timeLimit = times;
      const [start_date, end_date] = times;

      Object.assign(this.query, {
        start_date,
        end_date,
        page: 1,
      });
      this.refresh();
    },
    handleDateChange(date) {
      this.query.date = date;
      this.refresh();
    },
    handleMajorFilterChange(isMajor) {
      this.query.is_major = isMajor;
      this.refresh();
    },
    handleExpireNumbersChange() {
      this.query.page = 1;
      this.refresh();
    },
    handleDistinctChange(isDistinct) {
      this.query.is_distinct = isDistinct;
      this.refresh();
    },
    handleSearch() {
      if (this.lastKeyword === this.query.keyword) return;

      this.lastKeyword = this.query.keyword;
      this.query.page = 1;
      this.refresh();
    },
  },
  updated() {
    // 列会随权限/屏幕宽度/页签动态增减，重渲染后重新判断是否需要补列
    this.$nextTick(this.syncFillerColumn);
  },
  mounted() {
    this.setQueryParams(this.queryList);
    this.$nextTick(this.syncFillerColumn);
    window.addEventListener('resize', this.syncFillerColumn);
    if (window.ResizeObserver) {
      // 页签显隐、侧栏变化等容器尺寸变化不一定触发 window.resize
      this.resizeObserver = new window.ResizeObserver(this.syncFillerColumn);
      // 观察 VTable 根容器而不是表格本身：补列会让表格宽度变化，观察表格会多触发一轮回调
      this.resizeObserver.observe(this.$el);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.syncFillerColumn);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  },
};
</script>
